import React from 'react';
import style from './TAS.module.scss';
import Link from 'next/link';
import Head from 'next/head';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function TAS(props) {

  //check whether to render webp or png
  let imageType = "png"
  if (props.webp === "webp") {
    imageType = "webp"
  }

  return (
    <div className={style.TAS}>
      <Head>
        <title>Troubleshooting and Support | Basler Services</title>
      </Head>
      <div className={style.breadcrumbNav}>
        <li><Link href={'/e2-engineering-services'}><a>E&#178; Engineering Services</a></Link></li>
        <span>/</span>
        <li><Link href={'/e2-engineering-services/onsite-services'}><a><FontAwesomeIcon icon={['fal', 'chevron-left']} /> Onsite Services</a></Link></li>
        <span>/</span>
      </div>
      <h3>Troubleshooting and Support</h3>
      <p>When your unit is down, you need help. Our qualified, knowledgeable engineers have the necessary field experience to understand your issues and answer your questions.</p>
      <p>Basler Services&#39; engineers provide emergency troubleshooting services over the phone, free of charge. If your needs are more complex, we will dispatch one of our field engineers to your site based on time and materials required.</p>
      <p>We can guide you with issues with generator protection systems and generator synchronizing systems. Our expertise includes the following excitation and voltage regulator systems, some of which are no longer supported by the OEMs:</p>
      <p>
        <img alt="technical support grid" src={'/Assets/Images/Support_Grid.' + imageType}/>
      </p>
      <p>Our engineers gain satisfaction from drawing on their knowledge of how older equipment operates and how to solve difficult problems that other engineering firms may find too challenging. At the same time, our engineers use their expertise and experience to address issues with the latest innovations in generator protection and control technology.</p>
      <Link href={"/contact-us"}><a className={`${style.cta} ${style.primaryCta}`}>Contact Us <FontAwesomeIcon icon={['far', 'long-arrow-right']} /></a></Link>
    </div>
  );
}

export default TAS;